import _ from 'lodash';
import { AnyAction } from 'redux';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';
import { FAILURE_CUSTOMER_ADDRESSES, REQUEST_CUSTOMER_ADDRESSES, SUCCESS_CUSTOMER_ADDRESSES } from './actions';

/* Customer Addresses */
export function customerAddressReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_CUSTOMER_ADDRESSES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CUSTOMER_ADDRESSES: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_CUSTOMER_ADDRESSES:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}
